import { render, staticRenderFns } from "./tagSelect.vue?vue&type=template&id=b7024c8a&scoped=true"
import script from "./tagSelect.vue?vue&type=script&lang=js"
export * from "./tagSelect.vue?vue&type=script&lang=js"
import style0 from "./tagSelect.vue?vue&type=style&index=0&id=b7024c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7024c8a",
  null
  
)

export default component.exports